module.exports = __webpack_public_path__ + "img/20064.b2055f32.png";